import { App } from "@/App";

export const Root = () => (
    <div className="flex flex-col justify-center items-center p-0 min-h-screen m-0 bg-[#031926]">
        <App />
    </div>
);
